export const INDUSTRIES_BASE = "/industries";

export const SLUGS = {
  aerialDrones: "aerial-drones",
  adas: "adas-autonomous-vehicles",
  agriTech: "agritech-precision-agriculture",
  robotics: "robotics",
  construction: "construction",
  defence: "defense-security-surveillance",
  geospatial: "geospatial-satellite",
  marine: "marine-maritime",
  healthcare: "healthcare-medical-biological",
  manufacturing: "manufacturing",
  logistics: "logistics",
  energy: "energy-utilities",
  bfsi: "banking-finance-insurance",
  fashion: "fashion-retail-ecommerce",
  gaming: "gaming-entertainment-media",
  sports: "sports-analytics",
  government: "government-smart-cities",
  education: "education",
  hospitality: "hospitality-tourism",
  tech: "technology-telecommunications",
};

export const industryPath = (slug) => `${INDUSTRIES_BASE}/${slug}`;

export const LEGACY_INDUSTRY_REDIRECTS = {
  "/industries/agri-tech": "/industries/agritech-precision-agriculture",
  "/industries/defence-security": "/industries/defense-security-surveillance",
  "/industries/healthcare": "/industries/healthcare-medical-biological",
  "/industries/bfsi": "/industries/banking-finance-insurance",
};
